import { createFileRoute } from '@tanstack/react-router';
import { ActivityLogsRouteView } from '@/pages/workspaces/activity-logs/routing';

function ActivityLogsRoute() {
  const { workspaceId, tab } = Route.useParams();
  return <ActivityLogsRouteView segment="activity_logs" workspaceId={workspaceId} tab={tab} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab')({
  component: ActivityLogsRoute,
});
